export const managementFeeBillConstants = {
  GET_ALL_REQUEST: "MANAGEMENT_FEE_BILL_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "MANAGEMENT_FEE_BILL_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "MANAGEMENT_FEE_BILL_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "MANAGEMENT_FEE_BILL_RESET_ALL_SUCCESS"
};
